import { GlobalService } from '@23degrees/shared/services/global';
import { Component, inject, signal } from '@angular/core';
import { RESPONSE } from '@expressTokens';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.scss'],
  standalone: true,
})
export class NotFound404Component {
  private response = inject(RESPONSE, { optional: true });

  private readonly globalService = inject(GlobalService);

  public isServer = signal(this.globalService.isServer());

  constructor() {
    if (this.isServer() && this.response) {
      this.response.statusCode = 404;
      this.response.statusMessage = 'not found';
    }
  }
}
